module.exports = __webpack_public_path__ + "static/box-bg-8f36fa304f19eb12d21838cef2b6d840.jpg";